export default "__VITE_ASSET__1d3610d5__"